import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { PageContainer } from "@/features/ui";
import { Stack } from "@mui/material";

import { apiOutletClient } from "@/features/shared";
import { CustomTransactionHeader } from "@/features/ui";
import { ClaimTypeEnum } from "@/features/customer-claims/claim-type";
import {
  GeneralInformationSection,
  ProductVariantsSection,
} from "@/features/customer-claims/customer-claim";

export const CustomerClaim = () => {
  const { referenceNumber } = useParams();

  const [customerClaim, setCustomerClaim] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCustomerClaim = async () => {
      try {
        setLoading(true);
        const response = await apiOutletClient.get(
          `customer-claims/${referenceNumber}`
        );
        setCustomerClaim(response.data.data);
      } catch (error) {
        console.error("Error fetching customer claim:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCustomerClaim();
  }, [referenceNumber]);

  if (loading) {
    return null;
  }

  if (!customerClaim) {
    return null;
  }

  const breadcrumbPath =
    customerClaim.type === ClaimTypeEnum.RECEIVE
      ? "/sales/customer-claims/receive"
      : "/sales/customer-claims/delivery";

  return (
    <PageContainer
      maxWidth="xl"
      title={`Klaim Pelanggan ${referenceNumber}`}
      breadcrumbs={[
        { title: "Klaim Pelanggan", path: breadcrumbPath },
        { title: referenceNumber },
      ]}
    >
      <Stack spacing={3}>
        <CustomTransactionHeader
          referenceNumber={customerClaim.referenceNumber}
          status={customerClaim.status}
        />
        <GeneralInformationSection customerClaim={customerClaim} />
        <ProductVariantsSection
          customerClaimProductVariants={
            customerClaim.customerClaimProductVariants
          }
          warehouse={customerClaim.warehouse}
        />
      </Stack>
    </PageContainer>
  );
};
